import RenderFormForModal from "@/components/Form/Renderer/RenderFormForModal";
import { FormUIContext } from "@/context";
import { fetchEmployeeInfo, terminateEmployee } from "@/services/employee.services";
import { ExitEmployeeConfig } from "@/utils/constant/formConfig.constant";
import { toastErrorMessage, toastMessage } from "@/utils/helper/myToast";
import { filterTruthyValues } from "@/utils/helper/string";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FormSkeleton } from "@/common/ui/Loader";
import { useAppDispatch } from "@/store/store";
import { setPageEvent } from "@/store/features/dashboardSlice";

interface ExitEmployeeProps {
  onClose: (props?: any) => void;
  data: any;
}

const ExitEmployee: React.FC<ExitEmployeeProps> = ({ onClose, data }) => {
  const [isFormLoading, setIsFormLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useAppDispatch();
  const [formData, setFormData] = useState(null);
  const { employeeId } = useParams();

  const handleFormSubmit = async (formData: any) => {
    const res: any = await terminateEmployee(filterTruthyValues(formData));
    if (res?.status === 200) {
      const { message, isError } = res.data;
      onClose({ disabledWarning: true });
      dispatch(setPageEvent({ keys: ["Overview", "Employee details", "activities", "employeeData", "basicInfo"], type: "refresh" }));
      setTimeout(() => {
        dispatch(setPageEvent(null));
      }, 5000);
      return toastMessage(message, isError);
    } else {
      console.log("Error", res);
      const { message, isError } = res?.response?.data || {};
      if (message) {
        return toastMessage(message, isError);
      }
      if (res.message) {
        return toastMessage(res.message, true);
      }
    }
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        setIsLoading(true);
        const res = await fetchEmployeeInfo({ empId: employeeId, view_typ: "exit" });
        if (res) {
          setFormData(res);
        } else {
          return toastErrorMessage("failed to load data");
        }
      } catch (err) {
        console.error("Failed to fetch employee info", err);
      } finally {
        setIsLoading(false);
      }
    };
    if (data) {
      setFormData(data);
    } else {
      if (employeeId) {
        loadData();
      }
    }
  }, [data, employeeId]);

  if (isLoading) {
    return <FormSkeleton />;
  }
  if (!formData) return null;

  return (
    <FormUIContext.Provider value={{ isFormLoading, setIsFormLoading }}>
      <RenderFormForModal
        handleFormSubmit={handleFormSubmit}
        handleCancel={onClose}
        formConfig={ExitEmployeeConfig}
        defaultValues={formData}
        className="p-4 overflow-y-auto h-[calc(100%-30px)] "
        formClassName=""
        btnContainerClass="!p-4 sticky bottom-0 bg-white"
      />
    </FormUIContext.Provider>
  );
};

export default ExitEmployee;
